var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgViewChart(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.8333 2.08366H10.35C10 1.11699 9.08333 0.416992 8 0.416992C6.91667 0.416992 6 1.11699 5.65 2.08366H2.16667C1.25 2.08366 0.5 2.83366 0.5 3.75033V15.417C0.5 16.3337 1.25 17.0837 2.16667 17.0837H13.8333C14.75 17.0837 15.5 16.3337 15.5 15.417V3.75033C15.5 2.83366 14.75 2.08366 13.8333 2.08366ZM8 2.08366C8.45833 2.08366 8.83333 2.45866 8.83333 2.91699C8.83333 3.37533 8.45833 3.75033 8 3.75033C7.54167 3.75033 7.16667 3.37533 7.16667 2.91699C7.16667 2.45866 7.54167 2.08366 8 2.08366ZM9.66667 13.7503H3.83333V12.0837H9.66667V13.7503ZM12.1667 10.417H3.83333V8.75033H12.1667V10.417ZM12.1667 7.08366H3.83333V5.41699H12.1667V7.08366Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewChart);
export default __webpack_public_path__ + "static/media/viewChart.39b55060.svg";
export { ForwardRef as ReactComponent };